// Schema principal pour l'organisation
export const getOrganizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "ProfessionalService",
  "@id": "https://aurorerh.fr/#organization",
  "name": "Aurore RH",
  "alternateName": ["AuroreRH", "Aurore Ressources Humaines"],
  "legalName": "Aurore RH",
  "description": "Consultante RH et Droit Social - Accompagnement des entreprises, collectivités territoriales et particuliers en gestion RH, droit social et formation management. Expertise en recrutement, audit social et conformité",
  "url": "https://aurorerh.fr",
  "logo": {
    "@type": "ImageObject",
    "@id": "https://aurorerh.fr/#logo",
    "url": "https://aurorerh.fr/logo.png",
    "width": 800,
    "height": 600,
    "caption": "Logo Aurore RH"
  },
  "image": {
    "@type": "ImageObject",
    "@id": "https://aurorerh.fr/#primaryimage",
    "url": "https://aurorerh.fr/og-image.png",
    "width": 1200,
    "height": 630
  },
  "telephone": "+33750717728",
  "email": "contact@aurorerh.fr",
  "priceRange": "€€",
  "foundingDate": "2024",
  "slogan": "Un regard neutre et objectif sur vos problématiques RH",
  "founder": {
    "@type": "Person",
    "@id": "https://aurorerh.fr/#founder",
    "name": "Aurore",
    "jobTitle": "Consultante RH & Droit Social",
    "description": "Master en management et maîtrise en droit public, spécialisée en accompagnement RH opérationnel",
    "knowsAbout": [
      "Ressources Humaines",
      "Droit Social",
      "Droit du Travail",
      "Management",
      "Leadership",
      "Recrutement",
      "Formation professionnelle",
      "Gestion des conflits",
      "Audit RH",
      "Conformité sociale",
      "Qualité de vie au travail",
      "Risques psychosociaux"
    ],
    "alumniOf": {
      "@type": "EducationalOrganization",
      "name": "Formation en Management et Droit Public"
    }
  },
  "areaServed": {
    "@type": "Country",
    "name": "France"
  },
  "availableLanguage": ["fr", "French"],
  "serviceType": [
    "Conseil en Ressources Humaines",
    "Droit Social",
    "Droit du Travail",
    "Gestion des Conflits",
    "Formation Management",
    "Formation Leadership",
    "Recrutement",
    "Audit RH",
    "Accompagnement création entreprise",
    "Coaching professionnel",
    "Optimisation CV",
    "Négociation salariale"
  ],
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Services RH Aurore RH",
    "itemListElement": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "@id": "https://aurorerh.fr/#service-audit",
          "name": "Audit et conformité RH",
          "description": "Vérification des contrats de travail et obligations légales, analyse des processus internes, recommandations sur les mises en conformité",
          "provider": { "@id": "https://aurorerh.fr/#organization" }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "@id": "https://aurorerh.fr/#service-formation",
          "name": "Formation des managers",
          "description": "Formation au management positif, communication et gestion de conflits, développement du leadership",
          "provider": { "@id": "https://aurorerh.fr/#organization" }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "@id": "https://aurorerh.fr/#service-recrutement",
          "name": "Recrutement et sélection",
          "description": "Rédaction d'annonces, présélection CV, organisation entretiens, accompagnement au choix final",
          "provider": { "@id": "https://aurorerh.fr/#organization" }
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "@id": "https://aurorerh.fr/#service-coaching",
          "name": "Coaching professionnel",
          "description": "Optimisation CV et lettre de motivation, préparation entretiens, négociation salariale",
          "provider": { "@id": "https://aurorerh.fr/#organization" }
        }
      }
    ]
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "5.0",
    "reviewCount": "6",
    "bestRating": "5",
    "worstRating": "5"
  },
  "sameAs": [
    "https://www.linkedin.com/company/aurore-rh/",
    "https://www.instagram.com/aurore_rh/",
    "https://wa.me/+33750717728"
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+33-7-50-71-77-28",
    "contactType": "customer service",
    "email": "contact@aurorerh.fr",
    "availableLanguage": ["French"],
    "areaServed": "FR"
  }
});

// Schema FAQ optimisé
export const getFAQSchema = () => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "@id": "https://aurorerh.fr/#faq",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Quels sont les services proposés par Aurore RH ?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Aurore RH propose trois catégories de services : 1) Accompagnement pour particuliers (optimisation CV, coaching salarial, préparation entretiens, reconversion professionnelle), 2) Services professionnels (audit RH, conformité sociale, recrutement, gestion des conflits, accompagnement création d'entreprise), 3) Formations (management et leadership, droit du travail, communication professionnelle, gestion du stress et RPS)."
      }
    },
    {
      "@type": "Question",
      "name": "Quelle est la zone d'intervention d'Aurore RH ?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Aurore RH intervient sur toute la France, en présentiel ou en distanciel selon vos besoins et contraintes. Le premier rendez-vous gratuit de 30 minutes peut être réalisé en visioconférence pour plus de flexibilité."
      }
    },
    {
      "@type": "Question",
      "name": "Comment prendre rendez-vous avec Aurore RH ?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Vous pouvez prendre rendez-vous de 3 façons : 1) Réserver directement en ligne via Calendly sur le site, 2) Appeler au 07 50 71 77 28, 3) Envoyer un email à contact@aurorerh.fr. Réponse garantie sous 24h ouvrées."
      }
    },
    {
      "@type": "Question",
      "name": "Quelles sont les qualifications et l'expertise d'Aurore ?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Aurore possède un Master en management et une maîtrise en droit public. Elle est spécialisée dans l'accompagnement RH opérationnel des entreprises et collectivités, avec une expertise pointue en structuration des pratiques RH, recrutement, conformité sociale et formations managériales."
      }
    },
    {
      "@type": "Question",
      "name": "Le premier rendez-vous est-il gratuit ?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Oui, le premier échange de 30 minutes est entièrement gratuit et sans engagement. C'est l'occasion d'analyser votre situation, vos besoins et de vous proposer un accompagnement personnalisé adapté à vos enjeux."
      }
    },
    {
      "@type": "Question",
      "name": "Aurore RH travaille-t-elle avec les collectivités territoriales ?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Oui, Aurore RH accompagne les collectivités territoriales dans leurs problématiques RH spécifiques, notamment en matière de droit public, gestion des agents, conformité et structuration des services RH."
      }
    },
    {
      "@type": "Question",
      "name": "Quels sont les tarifs d'Aurore RH ?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Les tarifs sont établis sur devis personnalisé selon la nature de la mission, sa durée et sa complexité. Le premier rendez-vous de 30 minutes est gratuit pour évaluer vos besoins et établir un devis adapté."
      }
    }
  ]
});

// Schema BreadcrumbList
export const getBreadcrumbSchema = () => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "@id": "https://aurorerh.fr/#breadcrumb",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Accueil",
      "item": "https://aurorerh.fr/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "À propos",
      "item": "https://aurorerh.fr/#about"
    },
    {
      "@type": "ListItem",
      "position": 3,
      "name": "Services",
      "item": "https://aurorerh.fr/#services"
    },
    {
      "@type": "ListItem",
      "position": 4,
      "name": "Témoignages",
      "item": "https://aurorerh.fr/#testimonials"
    },
    {
      "@type": "ListItem",
      "position": 5,
      "name": "Contact",
      "item": "https://aurorerh.fr/#contact"
    }
  ]
});

// Schema WebSite avec SearchAction
export const getWebSiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": "https://aurorerh.fr/#website",
  "url": "https://aurorerh.fr",
  "name": "Aurore RH - Consultante RH & Droit Social",
  "description": "Accompagnement RH personnalisé pour entreprises, collectivités et particuliers. Expertise en droit social, recrutement, formations managériales.",
  "publisher": {
    "@id": "https://aurorerh.fr/#organization"
  },
  "inLanguage": "fr-FR"
});

// Schema des avis clients
export const getReviewsSchema = () => ({
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": "https://aurorerh.fr/#reviews",
  "name": "Aurore RH",
  "review": [
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Alexis"
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5",
        "worstRating": "1"
      },
      "reviewBody": "Travailler avec AuroreRH a été un vrai soulagement pour notre structure. En tant qu'agence web, nous avions besoin d'un support RH fiable et réactif. Mission accomplie !",
      "datePublished": "2024-11-15",
      "publisher": {
        "@type": "Organization",
        "name": "Wibeo"
      }
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Heloïse Lamotte"
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5",
        "worstRating": "1"
      },
      "reviewBody": "Nous avons fait appel à AuroreRH pour nous aider à recruter les bons profils, et son efficacité a été immédiate. Disponible, efficace et professionnelle, je recommande !",
      "datePublished": "2024-10-20",
      "publisher": {
        "@type": "Organization",
        "name": "Mains d'argent"
      }
    },
    {
      "@type": "Review",
      "author": {
        "@type": "Person",
        "name": "Lisa-May et Aurélie"
      },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": "5",
        "bestRating": "5",
        "worstRating": "1"
      },
      "reviewBody": "AuroreRH est intervenue ponctuellement pour renforcer notre équipe sur la gestion clients. Disponible, efficace et professionnelle, elle a su s'adapter rapidement à notre fonctionnement.",
      "datePublished": "2024-09-10",
      "publisher": {
        "@type": "Organization",
        "name": "Mes-Collegues"
      }
    }
  ]
});

// Schema WebPage pour la page d'accueil
export const getWebPageSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebPage",
  "@id": "https://aurorerh.fr/#webpage",
  "url": "https://aurorerh.fr/",
  "name": "Aurore RH - Consultante RH & Droit Social",
  "description": "Accompagnement RH personnalisé pour entreprises, collectivités et particuliers. Expertise en droit social, gestion des conflits, recrutement et formations managériales.",
  "isPartOf": {
    "@id": "https://aurorerh.fr/#website"
  },
  "about": {
    "@id": "https://aurorerh.fr/#organization"
  },
  "primaryImageOfPage": {
    "@id": "https://aurorerh.fr/#primaryimage"
  },
  "datePublished": "2024-01-01",
  "dateModified": "2025-01-02",
  "inLanguage": "fr-FR"
});
